import MainHeader from './MainHeader.jsx';
import './MainHeader.scss';

export default MainHeader;
